/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_PerspectiveInputs */

const en_vc_shots_perspective = /** @type {(inputs: Vc_Shots_PerspectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft Perspective Grid with artwork attached to its planes`)
};

const zh_vc_shots_perspective = /** @type {(inputs: Vc_Shots_PerspectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 透视网格，图稿贴附在透视平面上`)
};

/**
* | output |
* | --- |
* | "VectorCraft Perspective Grid with artwork attached to its planes" |
*
* @param {Vc_Shots_PerspectiveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_perspective = /** @type {((inputs?: Vc_Shots_PerspectiveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_PerspectiveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_perspective(inputs)
	return zh_vc_shots_perspective(inputs)
});
export { vc_shots_perspective as "vc.shots.perspective" }